import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";

import { Header, LoadingSpinner } from "../";
import { ActivityRating, EOYPrediction, CurriculumCoverage, PredictedPass, DashboardDemographics, DashboardCarousel, SubEOYPrediction } from "./";
import * as commonApi from "../../../api/commonApi";
import * as dashboardApi from "../../../api/dashboardApi";
import { hasAny, isEmptyArray, isEmptyObject } from "../../../util";
import { Common, RolesEnum, NavigationBar, Subjects } from "../../../helper";
import { setSelect } from "../../../store/stylesSlice";

import "../../../App.scss"
import "../../../assets/stlyes/Dashboard.scss"

const Dashboard = () => {
  const [classOptions, setClassOptions] = useState();
  const [adminClassOptions, setAdminClassOptions] = useState();
  const [demographicData, setDemographicData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const userData = useSelector((state) => state.login.user);
  const isNavCollapsed = useSelector((state) => state.styleData.isNavCollapsed)

  const getTeachersAllClassData = async () => {
    if (hasAny(userData.userType, [RolesEnum.Teacher])) {
      const getTeacherClass = await commonApi.getNavBar();
      if (!isEmptyArray(getTeacherClass.Items)) {
        const teacherClasses = getTeacherClass.Items.map((_class) => ({ value: _class.classId, label: _class.className }));
        setClassOptions(teacherClasses);
      }
    }
  };

  const getAdminOrLeadTeachersAllClassData = async () => {
    if (hasAny(userData.userType, [RolesEnum.Admin, RolesEnum.LeadTeacher])) {
      //   if (hasAny(userData.userType, [RolesEnum.Teacher])) {
      const getAdminClass = await commonApi.getNavBar();
      if (!isEmptyArray(getAdminClass.Items)) {
        const adminClasses = getAdminClass.Items.map((_class) => ({ value: _class.classId, label: _class.className }));
        adminClasses.push({ value: Common.All, label: Common.ViewSchool });
        setAdminClassOptions(adminClasses);
      } else {
        setAdminClassOptions([{ value: Common.All, label: Common.ViewSchool }])
      }
      // }
      // else {
      //   setAdminClassOptions([{ value: Common.All, label: Common.ViewSchool }])
      // }
    }
  }

  const getDemographicData = async () => {
    const details = await dashboardApi.getPupilBySchoolId();
    if (!isEmptyObject(details.Items)) {
      if (details.Items.totalPupil === 0 && details.Items.totalTeacher === 0) {
        setDemographicData({})
      } else {
        setDemographicData(details.Items)
      }
    }
  }

  const subject = [{ value: Subjects.Maths, label: Subjects.Maths }, { value: Subjects.Science, label: Subjects.Science }, { value: Subjects.Writing, label: Subjects.Writing }, { value: Subjects.Reading, label: Subjects.Reading }, { value: Subjects.PE, label: Subjects.PE }]

  useEffect(() => {
    if (hasAny(userData.userType, [RolesEnum.Admin, RolesEnum.LeadTeacher])) {
      setIsLoading(true)
      getAdminOrLeadTeachersAllClassData();
      getDemographicData();
    }
    else if (hasAny(userData.userType, [RolesEnum.Teacher])) {
      getTeachersAllClassData();
    }
    dispatch(setSelect(NavigationBar.Dashboard))
    setIsLoading(false);
  }, [])

  return (

    <div className="Page-layout">
      <Header />
      {isLoading && <LoadingSpinner />}
      <div className="Page-header nav-bar-collapsed" style={{ paddingRight: !isNavCollapsed ? "250px" : "75px", paddingBottom: "20px" }}>
        {(hasAny(userData.userType, [RolesEnum.Admin]) || hasAny(userData.userType, [RolesEnum.LeadTeacher])) ?
          <div className="dashMain">
            {(hasAny(userData.userType, [RolesEnum.LeadTeacher]) || hasAny(userData.userType, [RolesEnum.Teacher])) ? <Row>
              <Col xs={12}>
                <ActivityRating />
              </Col>
            </Row> : <></>}
            <Row >
              <Col>{(!isEmptyObject(demographicData) && !isLoading) ?  (<DashboardDemographics demographicData={demographicData} />) : (
                <div className="d-flex justify-content-center">
                  <h1>{Common.NoPupilFound}</h1>
                </div>
              )}</Col>
            </Row>
            <Row>
              <Col >{adminClassOptions && <CurriculumCoverage classOptions={adminClassOptions} />}</Col>
              <Col>{adminClassOptions && <PredictedPass classOptions={adminClassOptions} />}</Col>
            </Row>
            <Row><Col style={{ minWidth: "580px" }}>{adminClassOptions && <EOYPrediction classOptions={adminClassOptions} />}</Col></Row>
            <Row><Col style={{ minWidth: "580px" }}>{adminClassOptions && <SubEOYPrediction classOptions={adminClassOptions} subjectOption={subject} type={true} />}</Col></Row>
            <Row style={{ paddingRight: "10px" }}>{adminClassOptions && <Col xs={12} sm={12} style={{ height: "350px" }} className="dashbboard-help-section">
              <DashboardCarousel /></Col>}</Row>
          </div> :
          <div className="dashMain">
            <Row >
              <Col xs={12}><ActivityRating /></Col>
            </Row>
            {classOptions?.length > 0 ? <Row >
              <Col >{classOptions && <CurriculumCoverage classOptions={classOptions} />}</Col>
              <Col>{classOptions && <PredictedPass classOptions={classOptions} />}</Col>
            </Row> : <div className="d-flex justify-content-center">
              <h4>{Common.NoClassIsAssigned}</h4>
            </div>}
            <Row><Col style={{ minWidth: "580px" }}>{classOptions && <EOYPrediction classOptions={classOptions} />}</Col></Row>
            <Row style={{ paddingRight: "10px" }}>{classOptions && <Col xs={12} sm={12} style={{ height: "350px" }} className="dashbboard-help-section">
              <DashboardCarousel />
            </Col>}</Row>
          </div>}
      </div>
    </div >
  );
}

export { Dashboard };
